import { useEffect, useState } from "react"
import { Link, useSearchParams } from "react-router-dom";
import config from "../config";
import { Container, ItemList, ListItem, LoadingBar } from "./Elements";

export default function PersonList(props) {
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(true);

	const [data, setData] = useState([]);
	const [total, setTotal] = useState(0);
	const [notFound, setNotFound] = useState(false);
	
	const l = window.l;

	const urlParamsApiFields = {
		leit: 'q'
	}

	useEffect(() => {
		setLoading(true);
		setNotFound(false);

		let urlParams = [];

		for (const key of searchParams.keys()) {
			urlParams.push(urlParamsApiFields[key]+'='+searchParams.get(key));
		}

		fetch(config.apiRoot+'person?'+urlParams.join('&'))
			.then(res => res.json())
			.then(json => {
				setData(json.results);
				setTotal(json.count);
				setNotFound(json.count == 0);
				setLoading(false);
			});
	}, [searchParams]);

	return <Container className="relative">

		<LoadingBar loading={loading} />

		{
			notFound && <div className="font-lido text-center py-10">
				<div className="text-2xl">{l('Engin skjöl fundust með þessum leitarskilyrðum')}</div>
				<Link className="block text-xl text-sam_theme mt-5" to={'/archive/'}>{l('Sýna öll bréf')}</Link>
			</div>
		}

		{
			data.length > 0 && <ItemList>
			{
				data.map((item, index) => <ListItem key={index} link={'/archive?einstaklingur='+item.id} className="flex">
					<div className="w-1/3">{item.name}</div>
					<div>{item.description}</div>
				</ListItem>)
			}
			</ItemList>
		}

	</Container>
}